/**
 * Life API クライアント
 *
 * 詳細設計書 §6.3 に基づく。
 * 既存 axiosConfig.js の apiFetchAbsolute と同パターンで実装。
 */
import { apiFetchAbsolute } from '../../../api/axiosConfig';

// 接続先は他機能と同じ REACT_APP_API_URL から導出する。
// Life 専用の環境変数はデプロイワークフローで定義されておらず、
// 未定義のままだと localhost にフォールバックして検証・本番で疎通できないため。
// （sugitterApi.js と同じ方式）
const LIFE_API_BASE = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/dashboard', '/life')
  : 'http://localhost:8000/api/v1/life';

function lifeUrl(path) {
  return `${LIFE_API_BASE}${path}`;
}

/** 当日の自席情報取得（ページロード時の状態判定に使用） */
export async function getMySeat() {
  return apiFetchAbsolute(lifeUrl('/my-seat/'));
}

/** 全座席の占有状態取得（座席マップ表示用） */
export async function getSeatMap() {
  return apiFetchAbsolute(lifeUrl('/seat-map/'));
}

/** 出社登録・座席自動割り当て */
export async function checkIn() {
  return apiFetchAbsolute(lifeUrl('/check-in/'), {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/**
 * 退社確認情報取得（confirm=false）
 * ダイアログ表示時にサーバから最新情報を取得する場合に使用。
 * 初期実装ではローカルデータで代替しても可。
 */
export async function requestCheckOut() {
  return apiFetchAbsolute(lifeUrl('/check-out/'), {
    method: 'POST',
    body: JSON.stringify({ confirm: false }),
  });
}

/** 退社実行（confirm=true） */
export async function confirmCheckOut() {
  return apiFetchAbsolute(lifeUrl('/check-out/'), {
    method: 'POST',
    body: JSON.stringify({ confirm: true }),
  });
}
